var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepageTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1181,
    height: 954,
    viewBox: "0 0 1181 954",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.292 622.286C333.883 584.608 326.872 632.172 290.479 656.204C254.085 680.236 230.08 661.243 184.861 650.133C139.642 639.024 94.208 685.393 130.782 749.851C167.357 814.309 267.187 807.979 420.295 693.248C573.4 578.511 636.875 395.27 873.126 226.063C1109.38 56.8565 1214.43 96.9855 1214.43 96.9855C1214.43 96.9855 1265.56 116.589 1335.97 192.787C1406.38 268.977 1448.32 288.458 1448.32 288.458C1448.32 288.458 1352.47 326.565 1170 373.409C987.518 420.256 697.305 636.752 600.695 721.627C504.076 806.506 257.386 936.373 127.071 833.619C-3.252 730.869 80.5046 594.659 168.102 593.635C255.684 592.619 258.701 659.964 296.292 622.286ZM605.307 523.663C595.261 534.435 590.529 546.733 594.738 551.129C598.948 555.525 610.513 550.351 620.56 539.578C630.606 528.806 635.338 516.508 631.129 512.112C626.912 507.719 615.354 512.89 605.307 523.663ZM661.689 457.028C649.741 468.349 643.568 481.729 647.893 486.928C652.218 492.127 665.416 487.162 677.364 475.841C689.315 464.527 695.485 451.14 691.16 445.941C686.828 440.746 673.637 445.707 661.689 457.028ZM835.457 382.023C845.085 395.71 873.311 393.153 898.489 376.3C923.671 359.454 936.28 334.693 926.647 320.999C917.015 307.304 888.793 309.869 863.615 326.722C838.428 343.579 825.825 368.329 835.457 382.023ZM724.389 386.239C711.097 398.83 704.229 413.721 709.042 419.495C713.856 425.268 728.534 419.756 741.818 407.169C755.103 394.582 761.979 379.686 757.165 373.913C752.356 368.129 737.674 373.652 724.389 386.239ZM952.286 216.248C955.876 226.981 979.273 226.178 1004.54 214.459C1029.8 202.74 1047.37 184.54 1043.78 173.807C1040.19 163.073 1016.79 163.877 991.529 175.596C966.261 187.326 948.688 205.518 952.286 216.248ZM1178.83 122.699C1176.76 111.175 1152.93 108.871 1125.6 117.555C1098.28 126.238 1077.8 142.621 1079.86 154.14C1081.93 165.663 1105.75 167.971 1133.08 159.284C1160.42 150.604 1180.9 134.222 1178.83 122.699ZM899.704 275.142C918.542 263.772 930.679 248.027 926.812 239.966C922.936 231.908 904.52 234.588 885.673 245.962C866.835 257.332 854.698 273.077 858.566 281.139C862.449 289.193 880.865 286.512 899.704 275.142ZM837.772 302.743C833.281 295.874 816.715 300.259 800.772 312.553C784.837 324.843 775.564 340.375 780.058 347.252C784.549 354.121 801.114 349.736 817.058 337.442C833.001 325.148 842.274 309.616 837.772 302.743ZM959.874 296.365C967.588 314.845 1001 318.306 1034.49 304.103C1067.98 289.899 1088.88 263.402 1081.16 244.927C1073.44 226.451 1040.03 222.986 1006.54 237.19C973.051 251.393 952.153 277.89 959.874 296.365ZM1274.16 183.274C1267.76 159.579 1228.02 150.551 1185.4 163.11C1142.78 175.668 1113.41 205.06 1119.8 228.756C1126.2 252.452 1165.94 261.479 1208.56 248.921C1251.19 236.37 1280.56 206.981 1274.16 183.274ZM784.9 469.42C806.636 451.211 815.669 426.968 805.081 415.272C794.492 403.577 768.289 408.865 746.561 427.07C724.833 445.275 715.799 469.518 726.38 481.218C736.965 492.906 763.171 487.625 784.9 469.42ZM688.155 553.617C704.275 539.073 710.463 520.279 701.968 511.63C693.476 502.988 673.507 507.766 657.387 522.31C641.266 536.854 635.079 555.648 643.574 564.297C652.07 572.947 672.027 568.164 688.155 553.617ZM603.898 624.546C618.798 612.257 625.096 595.794 617.956 587.77C610.817 579.746 592.955 583.203 578.054 595.491C563.154 607.78 556.856 624.243 563.996 632.267C571.135 640.291 588.997 636.835 603.898 624.546ZM440.807 713.489C430.725 720.076 425.606 729.86 429.363 735.342C433.12 740.823 444.336 739.933 454.41 733.349C464.491 726.762 469.61 716.978 465.853 711.496C462.101 706.004 450.88 706.905 440.807 713.489ZM492.428 688.327C497.159 694.665 510.467 693.119 522.145 684.877C533.823 676.635 539.459 664.816 534.727 658.478C529.996 652.14 516.688 653.685 505.01 661.928C493.332 670.17 487.696 681.989 492.428 688.327Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1010.7 191.681L982.608 206.958L976.29 195.598L981.652 192.685L984.182 197.223L1006.91 184.858L1004.53 180.588L1009.89 177.667L1018.32 192.815L1012.95 195.731L1010.7 191.681Z",
    fill: "#59595B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1143.8 142.316L1142.18 137.968L1112.33 149.437L1107.8 137.253L1113.5 135.065L1115.31 139.937L1139.46 130.656L1137.75 126.074L1143.45 123.886L1149.5 140.129L1143.8 142.316Z",
    fill: "#59595B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M880.214 275.313L873.145 265.694L877.726 262.503L880.548 266.352L899.965 252.83L897.298 249.212L901.887 246.018L911.315 258.844L906.734 262.034L904.211 258.6L880.214 275.313Z",
    fill: "#59595B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M442.127 729.665L438.368 724.818L440.687 723.129L442.187 725.069L452.002 717.911L450.584 716.084L452.902 714.395L457.914 720.861L455.596 722.55L454.26 720.818L442.127 729.665Z",
    fill: "#59595B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1205.29 225.749C1192.17 229.812 1182.17 230.606 1175.3 228.141C1169.5 226.074 1165.7 221.897 1163.9 215.603C1162.09 209.309 1163.04 203.675 1166.76 198.701C1171.26 192.674 1180.03 187.645 1193.05 183.612C1206.33 179.502 1216.1 178.581 1222.38 180.849C1228.67 183.117 1232.71 187.41 1234.53 193.733C1236.34 200.027 1235.39 205.661 1231.67 210.636C1227.17 216.663 1218.38 221.694 1205.29 225.749ZM1218.46 206.089C1220.92 204.62 1222.49 203.138 1223.17 201.642C1223.85 200.146 1223.98 198.643 1223.55 197.13C1223.12 195.628 1222.23 194.445 1220.89 193.589C1219.55 192.733 1217.25 192.388 1213.99 192.561C1210.74 192.734 1205.05 194.075 1196.93 196.588C1188.82 199.102 1183.17 201.319 1179.99 203.24C1177.53 204.709 1175.97 206.188 1175.27 207.687C1174.59 209.184 1174.47 210.686 1174.9 212.199C1175.33 213.701 1176.22 214.88 1177.58 215.736C1178.94 216.584 1181.25 216.926 1184.5 216.753C1187.76 216.58 1193.44 215.239 1201.56 212.726C1209.67 210.209 1215.3 207.999 1218.46 206.089Z",
    fill: "#59595B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1024.86 287.147C1014.7 290.978 1006.83 292.091 1001.26 290.486C996.565 289.147 993.336 286.051 991.567 281.193C989.803 276.343 990.255 271.868 992.92 267.778C996.16 262.823 1002.82 258.446 1012.91 254.648C1023.19 250.768 1030.88 249.571 1035.98 251.045C1041.07 252.523 1044.51 255.692 1046.29 260.571C1048.05 265.421 1047.6 269.897 1044.93 273.987C1041.68 278.938 1034.99 283.326 1024.86 287.147ZM1034.22 271.065C1036.08 269.794 1037.24 268.546 1037.71 267.34C1038.17 266.126 1038.19 264.939 1037.76 263.782C1037.34 262.624 1036.58 261.731 1035.47 261.131C1034.36 260.524 1032.53 260.373 1029.96 260.662C1027.39 260.958 1022.96 262.287 1016.68 264.655C1010.4 267.027 1006.04 269.04 1003.63 270.704C1001.76 271.974 1000.6 273.222 1000.14 274.428C999.678 275.642 999.657 276.829 1000.08 277.987C1000.51 279.144 1001.28 280.034 1002.39 280.637C1003.52 281.237 1005.36 281.395 1007.92 281.099C1010.49 280.803 1014.91 279.478 1021.2 277.106C1027.49 274.723 1031.83 272.717 1034.22 271.065Z",
    fill: "#59595B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.817 622.719C581.294 622.593 579.285 621.453 577.794 619.285C576.302 617.117 575.977 614.878 576.801 612.576C577.809 609.786 580.603 606.894 585.192 603.887C589.87 600.821 593.574 599.369 596.314 599.508C599.055 599.648 601.17 600.81 602.668 602.992C604.159 605.16 604.485 607.399 603.661 609.702C602.652 612.492 599.843 615.39 595.238 618.405C590.62 621.434 586.813 622.872 583.817 622.719ZM592.153 613.912C595.011 612.043 596.939 610.564 597.931 609.485C598.71 608.649 599.135 607.915 599.218 607.27C599.3 606.625 599.164 606.046 598.806 605.526C598.449 605.006 597.954 604.666 597.328 604.495C596.701 604.323 595.755 604.453 594.503 604.894C593.248 605.328 591.197 606.481 588.34 608.35C585.482 610.219 583.547 611.703 582.546 612.785C581.767 613.621 581.342 614.355 581.26 615C581.177 615.645 581.313 616.224 581.671 616.744C582.028 617.264 582.523 617.604 583.157 617.772C583.792 617.94 584.735 617.803 585.99 617.369C587.245 616.935 589.299 615.789 592.153 613.912Z",
    fill: "#59595B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508.014 680.716C506.122 680.627 504.618 679.768 503.492 678.135C502.376 676.506 502.13 674.827 502.753 673.1C503.512 671.007 505.613 668.831 509.059 666.58C512.57 664.281 515.357 663.186 517.41 663.289C519.466 663.4 521.061 664.271 522.18 665.908C523.295 667.537 523.549 669.211 522.918 670.942C522.159 673.035 520.051 675.215 516.592 677.481C513.117 679.753 510.262 680.827 508.014 680.716ZM514.268 674.105C516.414 672.702 517.86 671.59 518.604 670.779C519.184 670.151 519.51 669.597 519.572 669.114C519.634 668.63 519.528 668.198 519.259 667.806C518.99 667.414 518.621 667.158 518.149 667.03C517.677 666.903 516.966 667.002 516.032 667.322C515.09 667.646 513.549 668.517 511.404 669.919C509.259 671.322 507.812 672.434 507.053 673.252C506.473 673.88 506.146 674.434 506.085 674.917C506.023 675.401 506.129 675.834 506.398 676.226C506.667 676.617 507.036 676.873 507.515 676.997C507.995 677.121 508.706 677.021 509.637 676.694C510.582 676.378 512.126 675.515 514.268 674.105Z",
    fill: "#59595B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M897.313 287.478C875.688 289.147 841.951 281.034 814 293.5C786.372 306.029 766.259 338.547 735.765 360.693C705.271 382.839 675.743 408.717 647.11 438.005C618.477 467.293 598.214 492.346 586.899 512.965C575.457 533.715 572.753 549.066 578.59 558.827C582.434 565.12 551.725 557.146 562 558.827C554.875 568.082 616.912 578.176 647.11 566C616.912 585.676 665.663 599.239 671.5 609C677.336 618.761 593.653 656.686 615.278 655.017C636.58 653.285 661.207 646.186 689.031 633.85C716.659 621.321 745.882 604.015 776.376 581.869C806.87 559.723 836.399 533.845 865.032 504.556C893.665 475.268 913.927 450.216 925.242 429.597C932.119 417.057 935.871 406.532 936.5 398.023L936.557 397.572C936.684 397.442 936.487 397.25 936.614 397.12L941.062 313.52C941.167 308.3 940.188 303.795 937.999 300.135C932.416 290.114 918.812 285.938 897.313 287.478Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M617.224 368.887C617.224 371.114 618.815 371.989 620.723 370.876L716.795 315.444C718.703 314.33 720.294 311.626 720.294 309.4V212.135C720.294 209.909 718.703 209.034 716.795 210.147L620.723 265.579C618.815 266.692 617.224 269.396 617.224 271.623V368.887Z",
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.86 263.909L713.932 208.477C714.886 207.92 715.761 207.841 716.397 208.239L719.26 209.909C718.624 209.591 717.749 209.591 716.795 210.147L620.723 265.579C618.815 266.692 617.224 269.396 617.224 271.623V368.887C617.224 369.921 617.622 370.717 618.178 371.114L615.474 369.524C614.759 369.206 614.281 368.41 614.281 367.217V269.953C614.361 267.726 615.952 265.022 617.86 263.909Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.723 265.579L716.795 210.147C718.703 209.034 720.294 209.909 720.294 212.135V215.953L617.224 275.52V271.623C617.224 269.476 618.815 266.692 620.723 265.579Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.437,
    y: 325.005,
    width: 123.27,
    height: 71.5763,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.934 254.843C696.515 256.831 693.731 255.24 693.731 251.264C693.731 247.367 696.515 242.516 699.934 240.607C703.354 238.698 706.138 240.209 706.138 244.186C706.138 248.162 703.275 252.934 699.934 254.843ZM699.934 242.913C697.628 244.265 695.719 247.526 695.719 250.23C695.719 252.934 697.628 253.968 699.934 252.695C702.241 251.343 704.149 248.083 704.149 245.379C704.149 242.675 702.241 241.561 699.934 242.913Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.663 351.789C634.243 353.777 631.46 352.186 631.46 348.21C631.46 344.233 634.243 339.462 637.663 337.553C641.083 335.565 643.867 337.155 643.867 341.132C643.787 345.029 641.003 349.8 637.663 351.789ZM637.663 339.859C635.357 341.211 633.448 344.472 633.448 347.176C633.448 349.88 635.357 350.914 637.663 349.641C639.97 348.289 641.878 345.029 641.878 342.325C641.878 339.621 639.97 338.507 637.663 339.859Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.191 295.403L674.088 288.643C674.485 288.006 674.485 287.291 674.088 287.052C673.69 286.813 673.054 287.211 672.736 287.847L668.839 294.607L664.942 292.38C664.544 292.142 663.908 292.539 663.59 293.176C663.192 293.812 663.192 294.528 663.59 294.766L667.487 296.993L663.59 303.753C663.192 304.389 663.192 305.105 663.59 305.344C663.749 305.423 664.067 305.423 664.305 305.264C664.544 305.105 664.783 304.867 665.021 304.548L668.918 297.788L672.815 300.015C672.974 300.095 673.292 300.095 673.531 299.936C673.769 299.777 674.008 299.538 674.247 299.22C674.644 298.584 674.644 297.868 674.247 297.629L670.191 295.403Z",
    fill: "#CACACB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.309 265.659L700.73 260.251C700.73 260.171 700.65 260.171 700.65 260.171C700.571 260.171 700.571 260.092 700.491 260.092C700.491 260.092 700.491 260.092 700.412 260.092C700.332 260.092 700.332 260.092 700.253 260.092H700.173C700.094 260.092 700.014 260.171 700.014 260.171C699.935 260.251 699.855 260.251 699.775 260.33L699.696 260.41C699.616 260.489 699.616 260.489 699.537 260.569C699.537 260.569 699.537 260.648 699.457 260.648C699.378 260.728 699.378 260.807 699.298 260.887C699.298 260.887 699.298 260.887 699.298 260.966C699.219 261.046 699.219 261.125 699.139 261.284L695.242 270.748C694.924 271.464 695.083 272.021 695.56 272.1C696.038 272.18 696.594 271.623 696.912 270.987L698.901 266.056C697.946 298.822 685.619 315.921 648.4 337.473C647.843 337.792 647.445 338.507 647.445 339.144C647.445 339.78 647.922 340.018 648.4 339.7C686.574 317.671 699.855 299.061 700.889 265.102L702.718 267.806C702.877 268.044 703.195 268.124 703.593 267.885C703.752 267.806 703.911 267.647 704.07 267.488C704.388 266.852 704.627 266.056 704.309 265.659Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.809 295.641C646.332 295.641 645.775 296.277 645.536 296.993C645.059 298.663 644.503 300.333 644.025 302.083C643.866 302.799 644.105 303.276 644.582 303.196C644.662 303.196 644.821 303.117 644.9 303.037C645.298 302.799 645.695 302.322 645.855 301.765C646.332 300.095 646.809 298.425 647.286 296.834C647.525 296.198 647.286 295.641 646.809 295.641ZM650.706 285.62C650.229 285.541 649.672 286.018 649.354 286.734C648.638 288.404 647.922 290.074 647.286 291.903C647.047 292.619 647.207 293.176 647.684 293.176C647.843 293.176 648.002 293.096 648.161 293.017C648.479 292.778 648.877 292.38 649.036 291.903C649.672 290.233 650.308 288.563 651.024 286.972C651.263 286.336 651.183 285.7 650.706 285.62ZM640.208 325.465C639.651 325.624 639.174 326.339 639.095 327.055C638.856 328.646 638.617 330.236 638.379 331.906C638.299 332.543 638.617 332.94 639.174 332.702C639.254 332.702 639.254 332.622 639.333 332.622C639.81 332.384 640.208 331.747 640.287 331.111C640.526 329.441 640.765 327.85 640.924 326.26C641.083 325.624 640.765 325.226 640.208 325.465ZM641.878 315.682C641.321 315.842 640.844 316.557 640.685 317.194C640.367 318.784 640.128 320.454 639.81 322.124C639.731 322.761 640.049 323.238 640.606 322.999C640.685 322.999 640.765 322.92 640.844 322.92C641.321 322.681 641.719 322.045 641.799 321.488C642.037 319.818 642.355 318.227 642.673 316.637C642.753 315.921 642.435 315.523 641.878 315.682ZM643.946 305.741C643.469 305.821 642.912 306.537 642.753 307.173C642.355 308.763 642.037 310.513 641.639 312.183C641.48 312.899 641.799 313.297 642.355 313.138C642.435 313.138 642.514 313.058 642.594 313.058C642.991 312.819 643.389 312.263 643.548 311.706C643.866 310.036 644.264 308.366 644.662 306.775C644.821 306.059 644.503 305.582 643.946 305.741ZM677.428 256.036C676.076 256.751 674.724 257.547 673.451 258.342C672.894 258.66 672.497 259.455 672.497 260.092C672.497 260.728 672.974 260.887 673.451 260.648C674.724 259.853 675.996 259.137 677.269 258.421C677.825 258.103 678.223 257.388 678.302 256.751C678.382 256.036 677.984 255.717 677.428 256.036ZM669.475 261.046C668.123 262.08 666.771 263.114 665.498 264.148C664.942 264.625 664.623 265.42 664.782 265.897C664.862 266.374 665.26 266.454 665.737 266.215C665.816 266.136 665.896 266.136 665.975 266.056C667.168 265.022 668.441 264.068 669.713 263.114C670.27 262.716 670.588 261.921 670.588 261.364C670.509 260.807 670.031 260.648 669.475 261.046ZM661.681 267.806C660.408 269.158 659.215 270.51 658.023 272.021C657.545 272.578 657.386 273.373 657.704 273.771C657.863 274.009 658.182 274.009 658.579 273.85C658.738 273.771 658.897 273.612 659.056 273.373C660.09 272.021 661.283 270.748 662.397 269.476C662.874 268.919 663.112 268.124 662.953 267.726C662.715 267.249 662.158 267.329 661.681 267.806ZM654.762 276.634C653.728 278.224 652.774 279.894 651.899 281.564C651.501 282.201 651.581 282.916 651.978 283.075C652.137 283.155 652.376 283.155 652.615 282.996C652.853 282.837 653.171 282.519 653.33 282.201C654.205 280.61 655.08 279.099 656.034 277.588C656.432 276.952 656.511 276.236 656.114 275.918C655.716 275.679 655.159 275.997 654.762 276.634ZM688.959 250.946L683.154 249.037C682.756 248.878 682.12 249.355 681.802 249.991C681.484 250.707 681.563 251.343 681.961 251.502L684.903 252.457C683.71 252.934 682.597 253.491 681.484 253.968C680.927 254.206 680.45 254.922 680.45 255.638C680.37 256.274 680.768 256.592 681.325 256.354C682.438 255.797 683.551 255.32 684.744 254.843L681.165 258.58C680.688 259.137 680.45 259.932 680.609 260.33C680.768 260.648 681.165 260.728 681.484 260.489C681.643 260.41 681.722 260.33 681.881 260.171L688.721 253.013C689.039 252.695 689.277 252.218 689.357 251.741C689.357 251.423 689.198 251.105 688.959 250.946Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.556 436.885C633.687 443.009 591.695 449.61 575.79 451.757L591.218 460.664C607.124 458.596 649.195 451.995 677.985 445.792L662.556 436.885Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.702 400.222C695.242 403.324 663.59 405.71 650.07 409.686L645.377 411.515L660.806 420.422L665.498 418.593C679.018 414.617 710.671 412.231 741.131 409.129L725.702 400.222Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.939 352.743C760.377 355.368 736.598 358.946 729.042 363.32L744.471 372.228L749.084 370.24C759.422 366.74 779.861 363.877 802.368 361.65L786.939 352.743Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.167 385.748C618.497 384.714 616.827 384.555 614.997 385.589C603.068 392.508 581.118 438.237 575.79 451.677L591.218 460.585C596.069 448.258 614.838 409.05 627.086 397.12C627.484 396.802 627.802 396.405 628.12 396.166C628.915 395.53 629.631 394.973 630.347 394.496C632.017 393.542 633.687 393.621 635.198 394.496L620.167 385.748Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.841 420.422C651.978 418.752 649.354 414.855 646.809 410.561C646.332 409.766 645.855 408.97 645.457 408.175C642.196 402.528 639.095 396.802 635.595 394.655C635.516 394.655 635.516 394.575 635.436 394.575L635.277 394.496C633.766 393.621 632.096 393.542 630.426 394.496C629.71 394.894 628.995 395.45 628.199 396.166C628.597 396.882 628.995 397.518 629.392 398.234C632.573 403.801 635.834 409.447 639.492 411.595L654.841 420.422Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.242 326.896C692.618 325.226 689.914 324.828 686.812 326.658C664.624 339.462 661.999 394.655 648.241 409.288C647.763 409.766 647.286 410.243 646.809 410.64C649.354 414.935 651.978 418.832 654.842 420.502L654.921 420.582C656.75 421.615 658.659 421.774 660.727 420.582C676.553 411.436 678.382 353.3 699.935 337.076C700.65 336.519 701.366 336.042 702.161 335.565C702.241 335.485 702.32 335.485 702.4 335.406C704.945 334.054 707.251 334.133 709.478 335.167L695.242 326.896Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.279 372.069C733.575 370.399 731.11 367.217 728.724 363.4C728.088 362.366 727.452 361.253 726.815 360.139C721.567 350.993 716.636 339.78 710.671 335.803C710.671 335.803 710.592 335.803 710.592 335.724L709.637 335.167C707.41 334.054 705.104 333.974 702.559 335.406C703.354 336.599 704.07 337.871 704.786 339.223C710.035 348.608 715.045 359.901 721.248 363.4C721.169 363.4 736.279 372.069 736.279 372.069Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.078 290.79L764.512 256.036L751.947 276.316L756.4 278.86C756.4 293.573 747.175 348.448 731.19 361.73C730.474 362.287 729.758 362.843 729.042 363.241C728.963 363.32 728.804 363.32 728.724 363.4C731.11 367.217 733.575 370.399 736.279 372.069C736.279 372.069 736.598 372.307 736.677 372.307C739.063 373.659 741.687 373.818 744.471 372.228C761.729 362.287 771.829 303.117 771.829 287.847L777.078 290.79Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.447 417.082H705.74L720.294 425.512L705.74 433.942H748.447L763.081 425.512L748.447 417.082Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.896 432.193H679.575L694.129 440.543L679.575 448.973H719.896L734.45 440.543L719.896 432.193Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.357 447.224H653.41L667.964 455.654L653.41 464.004H689.357L703.911 455.654L689.357 447.224Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.107 378.829L705.74 387.179V433.942L691.107 425.512V378.829Z",
    fill: "#F1ECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.294 378.829L705.74 387.179V433.942L720.294 425.512V378.829Z",
    fill: "#CACACB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.74 370.399L691.107 378.829L705.74 387.179L720.294 378.829L705.74 370.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.021 405.869L679.575 414.299V448.973L665.021 440.543V405.869Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.129 405.948L679.575 414.378V448.973L694.129 440.543V405.948Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.575 397.598L665.021 406.028L679.575 414.458L694.129 406.028L679.575 397.598Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.856 435.215L653.41 443.645V464.004L638.856 455.654V435.215Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.964 435.215L653.41 443.645V464.004L667.964 455.654V435.215Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.41 426.785L638.856 435.215L653.41 443.645L667.964 435.215L653.41 426.785Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.66 437.203C1069.51 433.068 1059.72 429.409 1047.24 426.149C1034.83 422.967 1020.44 420.422 1004.13 418.593C987.83 416.764 970.652 415.889 952.678 415.889C934.705 415.889 920.628 416.764 910.687 418.593C900.666 420.422 895.02 422.967 893.747 426.149C892.952 428.216 893.827 430.443 896.451 432.909C891.361 433.306 886.828 433.942 882.931 434.579C872.911 436.408 867.264 438.953 865.991 442.134C864.719 445.315 867.662 449.053 874.819 453.188C881.897 457.244 891.679 460.903 904.086 464.164C916.492 467.345 930.887 469.89 947.191 471.719C963.494 473.548 980.673 474.423 998.646 474.423C1016.62 474.423 1030.7 473.548 1040.64 471.719C1046.68 470.605 1051.14 469.253 1054 467.663L1054.16 467.583C1054.24 467.583 1054.24 467.504 1054.32 467.504L1081.91 451.518C1083.58 450.484 1084.7 449.371 1085.17 448.178C1086.61 444.997 1083.74 441.339 1076.66 437.203Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.62 315.285C793.62 265.022 828.931 244.663 872.433 269.794C915.936 294.925 951.247 356.083 951.247 406.346C951.247 456.608 915.936 476.968 872.433 451.836C828.931 426.626 793.62 365.547 793.62 315.285Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.403 398.075C965.403 347.812 930.092 286.654 886.589 261.523C864.798 248.957 845.155 247.765 830.919 255.956L816.842 264.068C831.078 255.877 850.801 257.069 872.513 269.635C916.015 294.766 951.326 355.924 951.326 406.187C951.326 431.318 942.498 448.894 928.263 457.165L942.18 449.132C956.495 441.02 965.403 423.285 965.403 398.075Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.321 324.908C810.321 285.302 838.156 269.237 872.433 289.04C906.71 308.843 934.546 357.038 934.546 396.643C934.546 436.249 906.71 452.314 872.433 432.511C838.156 412.708 810.321 364.513 810.321 324.908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.909 333.895C825.909 304.23 846.745 292.221 872.433 307.014C898.121 321.886 918.958 357.912 918.958 387.577C918.958 417.241 898.121 429.25 872.433 414.458C846.745 399.665 825.909 363.559 825.909 333.895Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.689 343.597C842.689 324.669 855.971 316.955 872.433 326.419C888.816 335.883 902.177 358.946 902.177 377.954C902.177 396.961 888.896 404.596 872.433 395.132C856.05 385.589 842.689 362.525 842.689 343.597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.027 353.538C860.027 345.585 865.594 342.404 872.513 346.381C879.352 350.357 884.919 359.98 884.919 367.933C884.919 375.886 879.352 379.067 872.513 375.091C865.594 371.194 860.027 361.491 860.027 353.538Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.584 414.855L868.059 364.513L873.388 359.503L919.992 409.925L914.584 414.855Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.558 427.819L743.994 439.191L739.381 448.973L759.025 437.68L763.558 427.819Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.381 448.973L737.075 447.621L741.687 437.839L743.994 439.191L739.381 448.973Z",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.994 439.191L741.688 437.839L761.252 426.467L763.558 427.819L743.994 439.191Z",
    fill: "url(#paint21_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.024 360.378C873.626 359.662 872.99 359.026 872.354 358.628C871.718 358.231 871.161 358.231 870.684 358.469L741.131 433.306L744.392 439.032L873.944 364.195C874.342 363.957 874.66 363.4 874.66 362.684C874.66 361.968 874.422 361.094 874.024 360.378Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.131 437.124C740.733 436.408 740.415 435.533 740.415 434.817C740.415 434.101 740.654 433.545 741.131 433.306C741.528 433.068 742.165 433.068 742.801 433.465C743.437 433.863 743.994 434.499 744.471 435.215C744.869 435.931 745.187 436.805 745.187 437.521C745.187 438.237 744.948 438.794 744.471 439.032C744.073 439.271 743.437 439.271 742.801 438.873C742.165 438.475 741.528 437.839 741.131 437.124Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.558 423.126L743.994 434.42L739.381 429.886L759.025 418.514L763.558 423.126Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.381 429.886L737.075 428.534L756.718 417.241L759.025 418.514L739.381 429.886Z",
    fill: "url(#paint22_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.994 434.42L741.687 433.068L737.075 428.534L739.381 429.886L743.994 434.42Z",
    fill: "url(#paint23_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.46 521.106C933.591 527.23 891.6 533.831 875.694 535.978L891.123 544.886C907.029 542.818 949.099 536.217 977.889 530.014L962.46 521.106Z",
    fill: "url(#paint24_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.61 484.443C995.147 487.545 963.494 489.931 949.974 493.907L945.282 495.737L960.711 504.644L965.403 502.815C978.923 498.838 1010.58 496.452 1041.04 493.351L1025.61 484.443Z",
    fill: "url(#paint25_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.84 436.885C1060.28 439.509 1036.5 443.088 1028.95 447.462L1044.38 456.37L1048.99 454.381C1059.33 450.882 1079.77 448.019 1102.27 445.792L1086.84 436.885Z",
    fill: "url(#paint26_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.071 469.969C918.401 468.935 916.731 468.776 914.902 469.81C902.973 476.729 881.023 522.458 875.694 535.899L891.123 544.806C895.974 532.479 914.743 493.271 926.99 481.342C927.388 481.024 927.706 480.626 928.024 480.387C928.82 479.751 929.535 479.194 930.251 478.717C931.921 477.763 933.591 477.842 935.102 478.717L920.071 469.969Z",
    fill: "url(#paint27_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.746 504.644C951.883 502.974 949.259 499.077 946.714 494.782C946.236 493.987 945.759 493.192 945.362 492.396C942.101 486.75 938.999 481.024 935.5 478.876C935.42 478.876 935.42 478.797 935.341 478.797L935.182 478.717C933.671 477.842 932.001 477.763 930.331 478.717C929.615 479.115 928.899 479.672 928.104 480.387C928.501 481.103 928.899 481.739 929.297 482.455C932.478 488.022 935.739 493.669 939.397 495.816L954.746 504.644Z",
    fill: "url(#paint28_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.147 411.117C992.522 409.447 989.818 409.05 986.717 410.879C964.528 423.683 961.903 478.876 948.145 493.51C947.668 493.987 947.191 494.464 946.713 494.862C949.258 499.156 951.883 503.053 954.746 504.723L954.825 504.803C956.655 505.837 958.563 505.996 960.631 504.803C976.457 495.657 978.287 437.521 999.839 421.297C1000.55 420.74 1001.27 420.263 1002.07 419.786C1002.15 419.707 1002.22 419.707 1002.3 419.627C1004.85 418.275 1007.16 418.355 1009.38 419.388L995.147 411.117Z",
    fill: "url(#paint29_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.18 456.29C1033.48 454.62 1031.01 451.439 1028.63 447.621C1027.99 446.587 1027.36 445.474 1026.72 444.361C1021.47 435.215 1016.54 424.001 1010.58 420.025C1010.58 420.025 1010.5 420.025 1010.5 419.945L1009.54 419.388C1007.31 418.275 1005.01 418.196 1002.46 419.627C1003.26 420.82 1003.97 422.092 1004.69 423.444C1009.94 432.829 1014.95 444.122 1021.15 447.621C1021.07 447.542 1036.18 456.29 1036.18 456.29Z",
    fill: "url(#paint30_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.98 375.011L1064.42 340.257L1051.85 360.537L1056.3 363.082C1056.3 377.795 1047.08 432.67 1031.09 445.951C1030.38 446.508 1029.66 447.065 1028.95 447.462C1028.87 447.542 1028.71 447.542 1028.63 447.621C1031.01 451.439 1033.48 454.62 1036.18 456.29C1036.18 456.29 1036.5 456.529 1036.58 456.529C1038.97 457.881 1041.59 458.04 1044.38 456.449C1061.63 446.508 1071.73 387.338 1071.73 372.069L1076.98 375.011Z",
    fill: "url(#paint31_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.781 475.377C893.827 475.377 892.952 475.536 892.077 476.093C891.679 476.331 890.248 477.127 889.055 477.842L888.498 477.524C888.26 477.365 887.862 477.365 887.623 477.524C887.544 477.524 876.966 483.648 876.966 483.648C876.807 483.728 876.728 483.807 876.648 483.966L876.171 484.682L786.065 540.432L779.782 550.214L796.324 545.045L881.261 495.896C881.579 496.055 881.897 496.055 882.136 495.896C882.215 495.896 892.793 489.772 892.793 489.772C892.952 489.692 893.031 489.613 893.111 489.454L893.906 488.34L897.883 486.034C899.553 485 900.666 483.171 900.666 481.103C900.587 478.002 897.962 475.377 894.781 475.377Z",
    fill: "url(#paint32_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.476 473.389C884.522 473.389 883.647 473.548 882.772 474.105C882.216 474.423 880.386 475.536 878.955 476.252C879.273 476.331 879.671 476.49 879.989 476.729C882.613 478.24 884.681 481.819 884.681 484.841C884.681 485.477 884.522 486.034 884.363 486.511L888.498 484.125C890.169 483.091 891.282 481.262 891.282 479.194C891.202 475.934 888.657 473.389 885.476 473.389Z",
    fill: "#CACACB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.487 540.83C776.362 541.307 776.998 542.5 776.998 543.454C776.998 544.011 776.76 544.408 776.362 544.488L786.94 542.977L789.166 539.796L786.94 533.99L782.406 531.366L774.294 540.909C774.533 540.591 774.931 540.591 775.487 540.83Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.487 540.83C775.01 540.511 774.613 540.591 774.294 540.83L774.135 540.989L770.397 545.363L776.283 544.488H776.362C776.76 544.408 776.998 544.011 776.998 543.454C776.998 542.5 776.283 541.307 775.487 540.83Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.219 491.76C867.821 491.521 867.344 490.965 867.185 490.567L865.355 485.875C865.196 485.477 865.276 484.761 865.515 484.443L867.264 481.898C867.503 481.501 868.059 481.421 868.457 481.66L872.115 483.807C872.513 484.046 872.99 484.602 873.149 485L874.978 489.692C875.138 490.09 875.058 490.806 874.819 491.124L873.07 493.669C872.831 494.066 872.275 494.146 871.877 493.907L868.219 491.76Z",
    fill: "#F1ECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.74 490.329L789.166 539.796L786.86 533.91L872.434 484.523L874.74 490.329Z",
    fill: "url(#paint33_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.434 493.589L786.86 542.977L789.166 539.796L874.74 490.328L872.434 493.589Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.434 484.523L786.86 533.91L782.406 531.366L867.9 481.978L872.434 484.523Z",
    fill: "url(#paint34_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.715 483.489L883.886 478.797C883.727 478.399 883.249 477.842 882.852 477.604L879.193 475.457C878.955 475.298 878.557 475.298 878.319 475.457C878.239 475.457 867.662 481.58 867.662 481.58C867.9 481.501 868.218 481.421 868.536 481.58L872.195 483.728C872.592 483.966 873.07 484.523 873.229 484.921L875.058 489.613C875.217 490.01 875.137 490.726 874.899 491.044L873.149 493.589C873.07 493.669 872.99 493.748 872.911 493.828L883.488 487.704C883.647 487.625 883.727 487.545 883.806 487.386L885.556 484.921C885.794 484.602 885.874 483.887 885.715 483.489Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.422 492.953C874.501 492.874 874.581 492.794 874.66 492.714L876.41 490.249C876.649 489.851 876.728 489.215 876.569 488.818L874.74 484.125C874.581 483.728 874.104 483.171 873.706 482.932L870.048 480.785C869.809 480.626 869.491 480.626 869.252 480.785L868.457 481.183C868.696 481.103 869.014 481.024 869.332 481.183L872.99 483.33C873.388 483.569 873.865 484.125 874.024 484.523L875.853 489.215C876.012 489.613 875.933 490.329 875.694 490.647L873.945 493.112C873.865 493.192 873.785 493.271 873.706 493.351L874.422 492.953Z",
    fill: "#F1ECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.012 492.078C876.092 491.999 876.171 491.919 876.251 491.84L878 489.295C878.239 488.897 878.319 488.261 878.159 487.863L876.33 483.171C876.171 482.773 875.694 482.217 875.296 481.978L871.638 479.831C871.399 479.672 871.081 479.672 870.843 479.831L870.047 480.228C870.286 480.149 870.604 480.069 870.922 480.228L874.581 482.376C874.978 482.614 875.455 483.171 875.614 483.569L877.444 488.261C877.603 488.658 877.523 489.374 877.285 489.692L875.535 492.158C875.455 492.237 875.376 492.317 875.296 492.396L876.012 492.078Z",
    fill: "#F1ECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.603 491.124C877.682 491.044 877.762 490.965 877.841 490.885L879.591 488.42C879.83 488.022 879.909 487.386 879.75 486.988L877.921 482.296C877.762 481.898 877.285 481.342 876.887 481.103L873.229 478.956C872.99 478.797 872.672 478.797 872.433 478.956L871.638 479.353C871.877 479.274 872.195 479.194 872.513 479.353L876.171 481.501C876.569 481.739 877.046 482.296 877.205 482.694L879.034 487.386C879.193 487.784 879.114 488.499 878.875 488.817L877.126 491.362C877.046 491.442 876.967 491.521 876.887 491.601L877.603 491.124Z",
    fill: "#F1ECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.318 287.768L986.399 283.791C985.763 275.6 980.355 266.215 973.595 261.523V253.57L971.05 252.059V260.092C964.29 256.91 958.802 260.012 958.245 267.488L951.326 263.511V266.454L958.245 270.43C958.882 278.622 964.29 288.006 971.05 292.699V300.731L973.595 302.242V294.21C980.355 297.391 985.842 294.289 986.399 286.813L993.318 290.79V287.768ZM983.774 282.28L973.515 276.395V264.545C978.923 268.283 983.138 275.759 983.774 282.28ZM970.97 263.034V274.884L960.711 268.999C961.268 263.114 965.562 260.648 970.97 263.034ZM960.711 271.941L970.97 277.827V289.676C965.562 285.939 961.268 278.463 960.711 271.941ZM973.515 291.187V279.338L983.774 285.223C983.138 291.108 978.923 293.573 973.515 291.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.345 255.956L802.13 253.57C801.732 248.639 798.471 242.913 794.415 240.13V235.278L792.904 234.404V239.255C788.769 237.346 785.508 239.175 785.19 243.709L780.975 241.323V243.072L785.19 245.458C785.588 250.389 788.848 256.115 792.904 258.899V263.75L794.415 264.625V259.773C798.551 261.682 801.812 259.853 802.13 255.32L806.345 257.706V255.956ZM800.619 252.616L794.415 249.037V241.879C797.676 244.186 800.221 248.719 800.619 252.616ZM792.825 241.005V248.162L786.621 244.583C787.019 241.084 789.644 239.573 792.825 241.005ZM786.701 246.413L792.904 249.991V257.149C789.644 254.843 787.019 250.309 786.701 246.413ZM794.415 258.024V250.866L800.619 254.445C800.221 257.944 797.676 259.455 794.415 258.024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.8 543.295L1010.02 540.909C1014.47 543.056 1021.07 543.056 1025.53 540.909L1029.74 543.295L1031.25 542.42L1027.04 540.034C1030.78 537.489 1030.78 533.672 1027.04 531.127L1031.25 528.741L1029.74 527.866L1025.53 530.252C1021.07 528.105 1014.47 528.105 1010.02 530.252L1005.8 527.866L1004.29 528.741L1008.51 531.127C1004.77 533.672 1004.77 537.489 1008.51 540.034L1004.29 542.42L1005.8 543.295ZM1011.53 539.955L1017.73 536.376L1023.94 539.955C1020.36 541.625 1015.19 541.625 1011.53 539.955ZM1025.45 539.08L1019.24 535.501L1025.45 531.922C1028.39 534.07 1028.39 537.012 1025.45 539.08ZM1023.94 531.048L1017.73 534.626L1011.53 531.048C1015.19 529.378 1020.36 529.378 1023.94 531.048ZM1010.02 531.922L1016.22 535.501L1010.02 539.08C1007.08 537.012 1007.08 534.07 1010.02 531.922Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.225 537.808C668.123 536.058 664.067 535.183 660.011 535.342H653.649V536.376C652.456 536.774 651.342 537.251 650.308 537.808C644.582 541.148 644.582 546.556 650.388 549.896C651.422 550.453 652.456 550.93 653.649 551.328V552.441H661.204C664.862 552.361 668.441 551.566 671.225 549.976C677.03 546.556 677.03 541.148 671.225 537.808Z",
    fill: "url(#paint35_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.867 549.896C640.924 548.226 639.492 545.999 639.492 543.772V538.762C639.492 540.989 640.924 543.136 643.867 544.886C649.672 548.226 658.977 548.226 664.783 544.886C667.646 543.215 669.077 541.068 669.077 538.841V543.852C669.077 545.999 667.646 548.226 664.783 549.896C659.057 553.236 649.672 553.236 643.867 549.896Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.946 544.886C638.14 541.545 638.14 536.137 643.866 532.797C649.593 529.457 658.977 529.457 664.783 532.797C670.588 536.137 670.588 541.545 664.862 544.886C659.057 548.226 649.672 548.226 643.946 544.886Z",
    fill: "url(#paint36_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.92 538.126L650.945 538.682L651.342 536.217H648.32L647.445 540.671L661.92 539.875V538.126Z",
    fill: "url(#paint37_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.643 577.811H704.388V583.537H735.643V577.811Z",
    fill: "url(#paint38_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.407 569.54H690.152V575.266H721.407V569.54Z",
    fill: "url(#paint39_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.812 573.516C686.812 568.983 689.675 568.903 689.675 568.903C689.675 568.903 691.186 568.903 693.731 567.869C696.197 566.836 699.696 567.233 697.787 570.812C697.787 570.892 697.787 570.892 697.708 570.971C697.549 571.13 697.39 571.369 697.072 571.528L690.789 575.186C689.914 575.663 686.892 574.47 686.812 573.516Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.892 573.118C686.971 574.073 689.914 575.266 690.868 574.709L697.151 571.051C697.39 570.892 697.708 570.653 698.026 570.414C697.946 570.573 697.946 570.653 697.867 570.812C697.867 570.892 697.867 570.892 697.787 570.971C697.628 571.13 697.469 571.369 697.151 571.528L690.868 575.186C689.993 575.663 687.289 574.629 686.892 573.755C686.892 573.675 686.892 573.596 686.892 573.596C686.812 573.357 686.812 573.198 686.892 573.118Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.005 568.267C688.721 568.267 691.345 568.903 691.345 568.903C691.345 568.903 691.345 569.301 691.584 569.54L691.663 569.619C692.141 569.937 692.697 570.573 691.504 571.289C690.471 571.925 689.675 571.528 689.357 571.13C689.198 570.812 688.96 570.494 688.641 570.335C688.323 570.176 688.085 570.096 688.005 570.017V569.937C688.005 569.937 687.687 568.267 688.005 568.267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.324 524.128C691.187 524.208 697.867 524.287 700.73 524.367C699.696 532.877 697.549 540.591 696.117 548.782C694.606 556.735 692.857 562.382 691.425 569.062C690.868 570.335 688.403 569.858 687.846 568.665C687.449 562.541 686.972 555.065 688.801 547.987C688.483 540.352 687.449 533.036 688.324 524.128Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.048 581.787C701.048 577.254 703.911 577.175 703.911 577.175C703.911 577.175 705.422 577.175 707.967 576.141C710.432 575.107 713.932 575.504 712.023 579.083C712.023 579.163 711.943 579.163 711.943 579.242C711.784 579.401 711.625 579.64 711.307 579.799L705.024 583.457C704.149 584.014 701.127 582.741 701.048 581.787Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.127 581.389C701.207 582.344 704.149 583.537 705.104 582.98L711.387 579.322C711.625 579.163 711.943 578.924 712.261 578.685C712.182 578.844 712.182 578.924 712.102 579.083C712.102 579.163 712.023 579.163 712.023 579.242C711.864 579.401 711.705 579.64 711.387 579.799L705.104 583.457C704.229 583.934 701.525 582.9 701.127 582.026C701.127 581.946 701.127 581.867 701.127 581.867C701.048 581.628 701.127 581.548 701.127 581.389Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.241 576.538C702.956 576.538 705.581 577.174 705.581 577.174C705.581 577.174 705.581 577.572 705.819 577.811L705.899 577.89C706.376 578.208 706.933 578.844 705.74 579.56C704.786 580.196 703.911 579.799 703.593 579.401C703.434 579.083 703.195 578.765 702.877 578.606C702.559 578.447 702.32 578.367 702.161 578.288V578.208C702.161 578.208 701.922 576.538 702.241 576.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.912 544.329C696.117 540.67 686.494 540.114 688.244 525.878C691.027 525.48 704.706 532.081 707.49 531.684C707.808 540.193 707.013 548.146 706.933 556.497C706.774 564.609 705.979 570.414 705.581 577.254C705.263 578.606 702.718 578.526 702.002 577.413C700.65 571.448 698.98 564.132 699.616 556.894C698.821 552.918 697.787 548.623 696.912 544.329Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.118 504.882C688.244 502.019 687.448 491.601 687.687 488.976C687.926 486.272 691.584 474.104 691.584 474.104C692.538 474.582 694.367 475.377 694.367 475.377C693.97 477.047 691.663 487.545 691.584 489.613C691.504 491.68 692.3 499.315 693.095 500.111C694.049 500.906 689.118 504.882 689.118 504.882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.091 483.728C713.614 486.034 711.625 493.192 709.955 496.85C709.16 498.599 706.535 501.065 704.627 502.496C703.911 503.053 702.957 503.133 702.161 502.655C701.446 502.258 700.65 501.701 699.855 501.144C697.867 499.713 696.435 498.281 695.481 498.122C687.607 497.407 688.005 510.131 687.687 526.196C688.721 530.014 691.266 532.24 694.208 533.513C700.253 536.058 706.138 535.421 707.728 531.286C706.138 524.128 704.945 518.482 705.581 511.324C709.478 508.302 712.659 503.689 714.091 499.315C715.92 493.907 716.874 486.034 717.033 484.682C717.113 484.602 715.84 484.205 714.091 483.728Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.027 500.11C692.3 498.44 692.3 496.055 692.061 494.384C691.743 493.51 691.584 492.555 691.584 491.521C691.584 487.863 693.97 484.682 696.833 484.841C702.638 485.239 701.605 488.34 701.525 491.999C701.525 495.418 699.934 497.804 697.31 498.122C697.31 498.679 697.867 499.713 698.742 500.19C697.23 501.86 694.447 502.099 693.254 501.94C692.061 501.86 690.47 501.065 691.027 500.11Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.06 482.932C698.901 482.455 698.026 482.217 695.083 483.569L694.367 483.887C688.959 486.591 690.709 492.953 691.663 494.544C691.982 495.1 692.22 495.577 692.22 496.532C694.367 496.293 695.163 497.486 696.515 496.214C697.469 495.259 698.901 494.146 699.139 493.748C699.378 493.271 699.298 493.033 699.298 492.714C699.139 489.613 700.65 491.442 700.65 492.158C701.207 491.84 701.127 490.647 700.968 489.215C705.343 485.398 702.639 483.091 699.06 482.932Z",
    fill: "#DC8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.409 483.807C714.568 483.409 714.568 482.535 714.25 482.217C713.932 481.819 713.455 479.831 714.647 479.592C714.568 479.194 715.443 478.32 716.795 479.115C718.067 479.831 718.465 481.103 718.147 481.898C717.829 482.694 717.033 483.966 716.874 484.602C716.397 484.364 714.409 483.807 714.409 483.807Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.902 474.184C692.061 473.548 691.504 471.878 691.902 471.082C692.3 470.287 692.936 469.492 694.049 469.969C695.163 470.446 695.481 471.082 695.401 471.719C695.72 472.037 695.958 472.912 695.163 473.468C694.368 474.105 694.129 474.423 693.97 475.138C693.652 474.979 691.902 474.184 691.902 474.184Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.454 501.224C711.864 504.167 706.694 509.097 705.104 509.654C703.513 510.211 702.4 511.324 702.479 511.642C702.559 511.96 703.752 513.949 703.672 516.653C703.593 519.277 704.229 530.491 707.569 531.684C707.649 531.525 707.728 531.366 707.808 531.207C706.217 524.049 705.024 518.402 705.661 511.245C708.921 508.7 711.705 504.962 713.454 501.224Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.56 474.661C810.401 474.264 810.401 473.468 810.719 473.15C811.037 472.753 811.434 470.923 810.401 470.685C810.401 470.367 809.605 469.492 808.412 470.208C807.219 470.923 806.822 472.037 807.14 472.832C807.458 473.548 808.174 474.82 808.333 475.377C808.73 475.218 810.56 474.661 810.56 474.661Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.016 570.892V565.961H829.646L827.976 570.892H855.016Z",
    fill: "url(#paint40_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.597 542.977C850.006 544.567 851.199 545.919 851.199 545.919C851.199 545.919 851.517 546.079 851.756 546.397C851.756 546.397 851.756 546.476 851.835 546.476C851.994 547.112 852.312 547.828 853.505 546.953C854.46 546.238 854.38 545.283 854.142 544.806C853.903 544.567 853.664 544.17 853.664 543.852C853.585 543.454 853.585 543.215 853.664 543.056H853.585C853.585 543.056 851.835 542.738 851.597 542.977Z",
    fill: "#FACFA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.233 542.738C851.199 543.295 850.404 544.567 851.358 545.919C840.463 544.488 832.669 544.09 831.396 542.738L835.293 537.171C842.848 538.046 844.519 540.432 852.233 542.738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.236 514.346C839.031 518.402 839.031 522.458 837.52 526.832C836.884 528.741 837.52 533.752 837.361 537.887L831.396 542.738C829.965 541.625 828.295 523.81 827.181 514.983C830.124 514.983 835.373 514.426 838.236 514.346Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.237 569.222C831.237 564.927 828.533 564.848 828.533 564.848C828.533 564.848 827.102 564.848 824.716 563.893C822.33 562.939 819.069 563.257 820.898 566.756C820.898 566.756 820.898 566.836 820.978 566.915C821.057 567.074 821.296 567.233 821.614 567.472L827.579 570.971C828.374 571.289 831.237 570.096 831.237 569.222Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.237 568.824C831.157 569.699 828.374 570.892 827.499 570.335L821.535 566.836C821.375 566.756 820.978 566.518 820.739 566.199C820.819 566.279 820.819 566.438 820.898 566.597C820.898 566.597 820.898 566.677 820.978 566.756C821.057 566.915 821.296 567.074 821.614 567.313L827.579 570.812C828.453 571.289 830.998 570.255 831.317 569.46C831.317 569.381 831.317 569.301 831.317 569.301C831.237 569.063 831.237 568.983 831.237 568.824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.726 563.893C828.931 563.893 826.624 564.609 826.624 564.609C826.624 564.609 826.624 565.006 826.386 565.325L826.306 565.404C825.75 565.802 825.272 566.358 826.465 567.154C827.499 567.79 828.294 567.392 828.692 566.995C828.851 566.677 829.09 566.358 829.408 566.199C829.726 566.04 829.965 565.881 830.124 565.881V565.802C830.124 565.802 830.044 563.893 829.726 563.893Z",
    fill: "#FACFA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.339 518.641C831.396 518.721 824.477 519.357 821.535 519.436C819.705 529.775 820.183 535.183 821.614 543.693C823.205 551.964 824.954 557.769 826.465 564.688C827.022 565.961 829.408 565.484 829.965 564.291C829.567 557.133 830.521 550.214 828.613 542.897C828.931 538.603 829.567 532.161 830.124 530.65C831.237 527.866 834.895 524.606 834.339 518.641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.429 497.407C840.304 494.464 841.099 484.046 840.94 481.342C840.701 478.638 836.963 466.311 836.963 466.311C836.009 466.788 834.18 467.583 834.18 467.583C834.578 469.253 836.884 479.831 836.963 481.978C837.043 484.046 836.248 491.76 835.373 492.635C834.498 493.43 839.429 497.407 839.429 497.407Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.645 466.47C836.486 465.834 837.043 464.163 836.645 463.289C836.247 462.493 835.611 461.698 834.498 462.175C833.384 462.652 832.987 463.368 833.066 463.925C832.748 464.243 832.51 465.118 833.305 465.754C834.1 466.39 834.339 466.708 834.498 467.504C834.895 467.265 836.645 466.47 836.645 466.47Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.719 474.105C811.196 475.059 814.457 484.125 815.172 485C816.922 486.909 820.024 488.022 824.318 488.817C824.795 488.897 825.829 488.977 825.909 488.897C826.386 488.658 827.022 488.42 827.738 487.784C829.885 486.113 831.078 485.08 832.112 484.921C840.701 483.171 839.588 498.281 838.872 514.585C838.236 518.959 837.281 519.357 835.691 520.311C831.873 522.379 823.205 524.128 820.978 519.834C822.569 515.937 823.921 510.211 824 505.996C824.08 503.292 822.171 501.224 821.535 498.202C821.614 497.486 821.773 496.85 821.932 496.293C815.65 492.794 811.594 489.295 810.957 487.625C809.367 483.648 808.015 476.331 807.856 475.377C808.333 474.264 809.685 473.707 810.719 474.105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.239 478.32C824.955 475.695 827.499 471.56 832.192 472.514C836.725 473.468 837.759 476.411 837.679 480.944C837.6 483.887 838.872 483.569 839.349 485.557C839.667 486.75 838.713 488.499 839.667 490.169C840.224 491.283 841.019 491.84 842.133 492.317C845.553 493.748 843.326 495.418 841.338 495.896C836.407 497.009 838.474 494.623 836.327 494.225C835.055 493.987 832.828 495.18 831.714 494.544C829.408 493.351 830.283 492.158 829.17 490.965C828.056 489.772 826.784 490.01 825.273 488.102C824.08 486.67 823.682 485.08 824.557 483.012C825.193 481.739 823.682 480.387 824.239 478.32Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.591 507.507C824.398 509.813 823.125 518.72 823.284 521.743C822.33 521.345 821.614 520.709 821.137 519.754C822.728 515.857 824.08 510.131 824.159 505.916C824.239 503.212 822.33 501.144 821.694 498.122C821.773 497.407 821.932 496.77 822.092 496.214C823.444 497.566 824.636 498.759 825.034 499.952C825.352 501.065 826.784 505.2 825.591 507.507Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.505 542.818C852.71 542.897 851.517 543.931 851.915 546.715C852.392 549.419 852.233 552.202 853.665 553.554C854.937 554.668 856.448 554.906 856.925 552.441C857.402 550.055 857.482 544.17 856.925 543.454C856.289 542.738 855.414 542.659 853.505 542.818Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.573 542.818C854.301 542.897 853.267 544.567 853.505 546.635C853.664 548.783 853.426 554.191 855.573 554.35C857.323 554.429 857.561 549.26 857.561 548.226C857.482 547.112 857.959 542.738 855.573 542.818Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.399 513.71H566.246L562.588 519.913H567.041L565.133 523.174H594.399V513.71Z",
    fill: "url(#paint41_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.791 458.278C568.791 458.835 570.779 466.231 571.256 467.027C571.893 468.06 572.926 469.174 573.245 469.89C573.483 470.605 573.722 471.957 573.722 472.275C573.722 472.594 573.245 473.866 572.847 473.707C572.37 473.548 573.086 472.912 572.847 472.673C572.767 472.912 572.211 473.389 571.813 473.309C571.336 473.23 571.495 473.071 571.495 473.071C571.256 473.15 570.938 473.15 570.859 472.991C570.62 473.071 570.302 473.23 570.222 472.753C570.143 472.275 570.063 471.401 569.904 471.082C569.268 470.049 569.348 467.583 569.189 467.265C569.03 466.947 566.564 460.823 566.405 459.471C566.166 458.199 566.246 451.598 567.359 451.598C568.473 451.439 568.791 456.449 568.791 458.278Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.133 513.392C563.781 513.631 563.383 515.778 564.019 517.209C564.417 517.687 565.53 518.164 565.53 518.164C565.53 518.164 569.825 519.913 570.779 519.993C571.733 520.072 573.881 519.675 574.04 518.084C573.881 517.05 573.006 516.812 571.972 516.176C570.62 515.38 569.427 514.187 568.393 513.631C567.518 513.153 565.133 513.392 565.133 513.392Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.757 511.96C567.121 512.04 564.973 512.597 564.973 512.597C564.973 512.597 564.178 514.824 565.451 515.221C567.837 516.017 569.904 514.346 568.95 513.79C568.314 513.472 567.677 512.994 567.757 511.96Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.779 519.516C569.745 519.436 565.371 517.607 565.371 517.607C565.371 517.607 564.337 517.209 563.86 516.732C563.94 516.891 563.94 517.05 564.019 517.209C564.417 517.687 565.53 518.164 565.53 518.164C565.53 518.164 569.825 519.913 570.779 519.993C571.733 520.072 573.881 519.675 574.04 518.084V518.005C573.642 519.277 571.733 519.516 570.779 519.516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.348 514.108C569.189 513.869 568.711 513.233 567.996 513.79C567.2 514.346 567.041 514.983 567.121 515.539C567.2 516.096 568.791 515.698 568.871 515.619C568.95 515.539 569.348 514.108 569.348 514.108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.064 514.824C569.745 514.983 568.95 515.46 568.632 516.255C568.552 516.494 568.234 516.573 568.075 516.494C567.837 516.414 567.757 516.096 567.837 515.937C568.314 514.983 569.189 514.346 569.745 514.108C569.984 514.028 570.223 514.108 570.302 514.346C570.382 514.426 570.302 514.744 570.064 514.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.415 515.698C571.097 515.857 570.302 516.335 569.984 517.13C569.904 517.368 569.586 517.448 569.427 517.368C569.189 517.289 569.109 516.971 569.189 516.812C569.666 515.857 570.541 515.221 571.097 514.983C571.336 514.903 571.574 514.983 571.654 515.221C571.733 515.301 571.654 515.539 571.415 515.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.359 468.538C567.996 476.65 569.109 484.364 569.109 490.885C569.109 498.282 567.837 506.155 567.757 512.358C567.837 514.267 565.689 515.778 564.735 514.108C564.735 513.551 564.974 512.835 564.894 512.04C564.337 507.268 562.747 500.031 564.099 493.828C562.19 485.716 557.021 475.616 557.816 469.253C560.122 468.06 565.53 467.981 567.359 468.538Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.325 442.85C568.473 443.883 569.188 445.474 569.188 448.655C567.757 447.78 566.325 442.85 566.325 442.85Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.212 471.639V472.991L564.019 472.275L565.212 471.639Z",
    fill: "#423EAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.486 516.653C558.134 516.891 557.736 519.039 558.373 520.47C558.77 520.947 559.884 521.425 559.884 521.425C559.884 521.425 564.178 523.174 565.133 523.254C566.087 523.333 568.234 522.936 568.393 521.345C568.234 520.311 567.359 520.073 566.326 519.436C564.974 518.641 563.781 517.448 562.747 516.891C561.872 516.414 559.486 516.653 559.486 516.653Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.031 515.221C561.395 515.301 559.247 515.857 559.247 515.857C559.247 515.857 558.452 518.084 559.725 518.482C562.11 519.277 564.178 517.607 563.224 517.05C562.588 516.732 561.951 516.255 562.031 515.221Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.132 522.776C564.099 522.697 559.724 520.868 559.724 520.868C559.724 520.868 558.691 520.47 558.213 519.993C558.293 520.152 558.293 520.311 558.372 520.47C558.77 520.947 559.883 521.424 559.883 521.424C559.883 521.424 564.178 523.174 565.132 523.254C566.087 523.333 568.234 522.936 568.393 521.345V521.265C567.916 522.538 566.007 522.856 565.132 522.776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.701 517.369C563.542 517.13 563.065 516.494 562.349 517.05C561.554 517.607 561.395 518.243 561.474 518.8C561.554 519.357 563.144 518.959 563.224 518.88C563.303 518.8 563.701 517.369 563.701 517.369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.417 518.084C564.099 518.243 563.303 518.721 562.985 519.516C562.906 519.754 562.588 519.834 562.429 519.754C562.19 519.675 562.11 519.357 562.19 519.198C562.667 518.243 563.542 517.607 564.099 517.369C564.337 517.289 564.576 517.368 564.655 517.607C564.735 517.766 564.655 518.005 564.417 518.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.769 518.959C565.45 519.118 564.655 519.595 564.337 520.391C564.258 520.629 563.939 520.709 563.78 520.629C563.542 520.55 563.462 520.232 563.542 520.072C564.019 519.118 564.894 518.482 565.45 518.243C565.689 518.164 565.928 518.243 566.007 518.482C566.087 518.561 565.928 518.88 565.769 518.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.906 472.037C562.906 479.513 562.985 487.784 562.985 494.305C562.985 501.701 562.11 509.416 562.031 515.619C562.11 517.528 559.963 519.039 559.009 517.369C559.009 516.812 559.247 516.096 559.168 515.301C558.611 510.529 557.021 503.292 558.373 497.089C556.464 488.977 553.601 480.387 555.35 472.116C557.657 470.923 561.156 471.401 562.906 472.037Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.339 462.414C557.975 456.767 555.271 451.518 554.794 448.019C554.476 445.792 554.237 443.247 556.305 442.611C558.373 441.975 559.247 441.657 560.997 441.736C565.292 441.816 567.359 442.691 568.234 445.713C569.029 448.496 569.666 449.371 570.302 452.075C570.62 453.268 567.2 455.972 567.598 461.301C570.62 465.834 572.767 476.093 573.642 484.125C573.96 486.591 571.495 489.692 567.121 491.84C561.633 494.623 555.191 494.782 552.805 492.317C552.249 491.681 551.931 491.044 551.931 490.249C551.931 487.466 553.601 467.106 557.339 462.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.406 436.408C559.486 435.056 564.019 437.76 563.939 439.509C563.86 440.941 563.701 442.372 564.178 442.532C564.814 443.009 566.643 447.701 565.53 448.814C561.633 447.224 559.645 443.884 556.225 442.532C557.657 442.293 559.168 440.782 559.406 436.408Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.373 434.579L559.725 431.159H568.393V436.408C568.393 439.271 566.485 441.657 564.019 441.657C561.713 441.657 559.804 439.43 559.725 436.726H559.088L558.373 434.579Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.52 439.35C561.236 440.702 562.508 441.577 563.94 441.657C563.94 442.054 564.019 442.372 564.178 442.532C563.94 442.532 563.701 442.532 563.462 442.452C561.951 442.054 560.917 440.861 560.52 439.35Z",
    fill: "#F2C39D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.462 427.58H563.542C568.234 427.66 568.632 431.238 568.393 431.795C566.882 432.352 565.928 431.318 564.973 431.397C564.496 431.397 562.667 431.716 561.872 432.67C561.076 433.704 561.315 435.374 560.52 435.374C560.202 435.374 560.043 434.26 559.565 434.181C559.168 434.181 558.691 434.579 558.77 435.215C558.85 436.09 559.645 436.646 559.565 437.044C559.327 437.76 557.657 436.487 557.657 434.022C557.736 431.556 559.406 427.341 563.462 427.58Z",
    fill: "#D6952D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.112 465.118L554.158 467.424C550.897 465.754 548.988 461.3 548.829 457.722C548.591 452.95 553.521 444.838 553.84 444.44C555.112 442.532 558.055 444.202 557.1 446.667C556.862 447.144 551.772 455.495 552.328 458.358C552.726 460.267 553.362 463.845 555.112 465.118Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.906 427.578C557.895 427.976 557.259 432.907 555.271 434.259C554.078 435.054 551.374 433.543 549.863 436.247C548.034 439.348 550.976 440.462 549.068 441.814C547.159 443.166 545.727 447.142 548.909 449.608C552.09 452.073 556.066 449.926 555.589 446.267C555.271 443.643 556.066 442.291 558.214 443.166C559.884 443.802 560.44 442.53 559.725 440.859C563.383 441.257 559.566 434.259 565.053 431.395C564.814 429.964 562.906 427.578 562.906 427.578Z",
    fill: "#D6952D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.112 465.118C555.51 465.356 557.577 464.879 558.055 464.879C558.532 464.879 559.884 464.879 561.077 465.277C562.19 465.675 562.985 466.072 562.19 466.231C562.588 466.311 563.622 466.708 562.826 466.947C562.747 467.186 562.429 467.583 561.633 467.583C561.315 467.822 559.327 468.219 558.77 468.14C558.134 468.299 554.714 468.299 554.237 467.504C554.158 466.152 555.112 465.118 555.112 465.118Z",
    fill: "#FCD1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.768 558.167H596.626V563.734H626.768V558.167Z",
    fill: "url(#paint42_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.373 552.918H581.436V558.644H612.373V552.918Z",
    fill: "url(#paint43_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.175 556.815C578.175 552.361 581.038 552.202 581.038 552.202C581.038 552.202 582.549 552.202 585.094 551.168C587.56 550.134 591.059 550.532 589.071 554.111C589.071 554.191 589.071 554.191 588.991 554.27C588.912 554.429 588.673 554.668 588.355 554.827L582.152 558.485C581.197 559.042 578.175 557.769 578.175 556.815Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.175 556.417C578.255 557.372 581.197 558.565 582.152 558.008L588.355 554.35C588.594 554.27 588.912 554.031 589.23 553.713C589.15 553.872 589.15 553.952 589.071 554.111C589.071 554.191 589.071 554.191 588.991 554.27C588.912 554.429 588.673 554.668 588.355 554.827L582.152 558.485C581.277 558.962 578.573 557.928 578.255 557.054C578.255 556.974 578.255 556.895 578.255 556.895C578.175 556.656 578.175 556.576 578.175 556.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.368 551.646C580.084 551.646 582.629 552.282 582.629 552.282C582.629 552.282 582.629 552.6 582.868 552.918L582.947 552.998C583.424 553.316 583.981 553.872 582.788 554.668C581.834 555.304 581.038 554.906 580.641 554.509C580.482 554.191 580.243 553.872 579.925 553.713C579.607 553.554 579.368 553.475 579.289 553.395V553.316C579.289 553.316 579.05 551.646 579.368 551.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.289 507.905C582.072 507.984 589.071 508.064 591.854 508.143C590.82 516.573 588.753 524.208 587.321 532.32C585.81 540.273 584.14 545.84 582.629 552.361C582.072 553.554 579.607 553.157 579.13 551.964C578.732 545.919 578.255 538.523 580.084 531.525C579.845 523.969 579.13 515.539 579.289 507.905Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.172 561.825C592.172 557.372 595.035 557.213 595.035 557.213C595.035 557.213 596.546 557.213 599.091 556.179C601.557 555.145 605.056 555.543 603.068 559.121C603.068 559.201 602.988 559.201 602.988 559.28C602.909 559.439 602.67 559.678 602.352 559.837L596.149 563.495C595.194 563.973 592.172 562.78 592.172 561.825Z",
    fill: "#C0162E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.172 561.428C592.252 562.382 595.194 563.575 596.149 563.018L602.352 559.36C602.591 559.201 602.909 559.042 603.227 558.724C603.147 558.883 603.147 558.962 603.068 559.121C603.068 559.201 602.988 559.201 602.988 559.28C602.909 559.44 602.67 559.678 602.352 559.837L596.149 563.495C595.274 563.973 592.57 562.939 592.252 562.064C592.252 561.984 592.252 561.905 592.252 561.905C592.172 561.666 592.172 561.587 592.172 561.428Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.286 556.656C594.002 556.656 596.546 557.292 596.546 557.292C596.546 557.292 596.546 557.61 596.785 557.928L596.865 558.008C597.342 558.326 597.898 558.883 596.706 559.678C595.751 560.314 594.956 559.917 594.558 559.519C594.399 559.201 594.161 558.883 593.842 558.724C593.524 558.565 593.286 558.485 593.206 558.406V558.326C593.206 558.326 592.968 556.656 593.286 556.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.037 524.685C587.242 521.106 578.414 520.629 579.05 506.394C581.834 505.996 595.831 512.517 598.535 512.12C598.853 520.629 598.058 528.503 597.978 536.774C597.819 544.806 597.024 550.612 596.626 557.372C596.308 558.644 593.763 558.644 593.047 557.531C591.695 551.566 590.025 544.409 590.661 537.171C589.946 533.195 588.912 528.98 588.037 524.685Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.617 480.228C578.175 484.682 575.153 490.408 574.835 493.112C574.358 497.486 576.346 500.349 579.289 507.427C579.289 507.427 579.368 502.735 579.448 500.985C579.13 499.872 578.175 496.611 578.414 494.862C578.653 493.351 583.106 490.01 583.663 488.42C585.015 484.364 582.549 483.171 584.617 480.228Z",
    fill: "url(#paint44_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.27 472.355C616.747 471.401 617.224 470.923 617.622 471.003C617.781 470.844 618.019 470.605 618.178 470.446C619.292 469.333 621.36 468.935 621.519 469.412C621.598 469.731 620.564 469.89 619.849 470.367C619.371 470.685 619.292 470.923 619.053 471.162C619.053 471.162 620.723 472.196 620.008 473.707C619.371 474.9 618.974 474.105 619.133 473.866C618.099 474.82 617.86 473.866 617.145 474.741L615.634 472.912C615.713 472.912 615.952 472.673 616.27 472.355Z",
    fill: "#E9B98C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.475 472.912C614.838 473.23 608.635 478.797 606.329 480.387C603.943 481.103 600.523 482.296 598.694 482.694C597.342 482.773 596.626 482.773 594.161 481.501C591.775 480.228 589.15 479.831 588.116 479.672C579.925 478.002 578.096 493.271 578.732 508.859C579.925 512.676 581.675 513.392 585.094 514.824C588.037 516.017 596.865 517.687 599.171 513.71C598.376 506.075 596.865 497.566 598.376 490.249C601.875 488.499 606.17 487.545 609.271 485C613.963 481.024 616.19 476.331 617.065 475.059C617.622 474.582 616.906 472.753 615.475 472.912Z",
    fill: "url(#paint45_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.43 485C608.635 485.636 601 488.261 597.819 488.897C594.638 489.533 596.149 490.329 596.467 492.158C596.865 494.623 597.183 504.882 598.853 509.336C598.137 502.974 597.342 496.293 598.535 490.329C602.114 488.499 606.329 487.545 609.43 485Z",
    fill: "url(#paint46_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.333 479.91C587.162 478.558 586.923 477.683 586.605 475.934C586.287 474.979 586.049 473.946 586.049 472.832C586.049 468.776 588.594 465.356 591.775 465.515C598.137 465.913 596.944 469.253 596.944 473.309C596.944 477.047 595.274 479.592 592.411 479.99C592.411 480.626 592.968 480.944 593.763 481.262C591.695 482.535 588.594 482.694 587.242 482.137C585.969 481.739 584.458 480.785 585.333 479.91Z",
    fill: "#E9B98C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.842 481.342C593.842 481.103 593.445 480.387 592.809 480.706C590.741 481.66 588.116 481.66 586.446 480.706C586.049 480.467 585.651 480.069 585.81 479.592C585.333 479.513 585.174 479.91 585.094 480.069C585.015 480.308 584.856 480.944 585.731 481.58C586.605 482.217 589.548 483.728 593.842 481.342Z",
    fill: "url(#paint47_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 699.928,
    y1: 252.547,
    x2: 695.967,
    y2: 245.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 637.656,
    y1: 349.486,
    x2: 633.683,
    y2: 342.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 704.459,
    y1: 293.199,
    x2: 614.551,
    y2: 352.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 663.77,
    y1: 332.772,
    x2: 663.77,
    y2: 249.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 626.887,
    y1: 436.885,
    x2: 626.887,
    y2: 460.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 645.344,
    y1: 410.367,
    x2: 741.117,
    y2: 410.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4444,
    stopColor: "#E5E8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8529,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 765.705,
    y1: 352.743,
    x2: 765.705,
    y2: 372.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 605.386,
    y1: 460.585,
    x2: 605.386,
    y2: 384.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 641.472,
    y1: 420.422,
    x2: 641.472,
    y2: 393.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 678.03,
    y1: 421.418,
    x2: 678.03,
    y2: 325.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 719.358,
    y1: 372.069,
    x2: 719.358,
    y2: 334.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 752.814,
    y1: 373.371,
    x2: 752.814,
    y2: 256.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 734.411,
    y1: 417.082,
    x2: 734.411,
    y2: 433.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 707.013,
    y1: 432.193,
    x2: 707.013,
    y2: 448.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 678.661,
    y1: 447.224,
    x2: 678.661,
    y2: 464.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 646.107,
    y1: 464.004,
    x2: 646.107,
    y2: 435.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 653.358,
    y1: 443.645,
    x2: 653.358,
    y2: 426.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 975.618,
    y1: 415.889,
    x2: 975.618,
    y2: 474.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 890.854,
    y1: 457.165,
    x2: 890.854,
    y2: 250.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 894.026,
    y1: 359.503,
    x2: 894.026,
    y2: 414.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 740.522,
    y1: 448.973,
    x2: 740.522,
    y2: 437.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 752.583,
    y1: 439.191,
    x2: 752.583,
    y2: 426.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 748.01,
    y1: 429.886,
    x2: 748.01,
    y2: 417.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 737.075,
    y1: 431.477,
    x2: 743.994,
    y2: 431.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 926.792,
    y1: 521.106,
    x2: 926.792,
    y2: 544.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 993.159,
    y1: 484.443,
    x2: 993.159,
    y2: 504.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 1065.61,
    y1: 436.885,
    x2: 1065.61,
    y2: 456.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 935.102,
    y1: 500.535,
    x2: 846.898,
    y2: 564.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 954.746,
    y1: 489.079,
    x2: 922.203,
    y2: 519.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 1009.38,
    y1: 449.515,
    x2: 905.339,
    y2: 512.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 1036.18,
    y1: 434.219,
    x2: 990.745,
    y2: 471.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 1076.98,
    y1: 388.969,
    x2: 981.403,
    y2: 425.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 840.224,
    y1: 475.377,
    x2: 840.224,
    y2: 550.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 830.641,
    y1: 539.796,
    x2: 830.641,
    y2: 484.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 782.406,
    y1: 507.944,
    x2: 872.434,
    y2: 507.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 646.05,
    y1: 543.84,
    x2: 675.597,
    y2: 543.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4265,
    stopColor: "#C4C9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5766,
    stopColor: "#D7DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8459,
    stopColor: "#F4F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 654.364,
    y1: 530.292,
    x2: 654.364,
    y2: 547.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 661.92,
    y1: 538.066,
    x2: 658.638,
    y2: 547.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 720.016,
    y1: 577.811,
    x2: 720.016,
    y2: 583.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 705.78,
    y1: 569.54,
    x2: 705.78,
    y2: 575.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 841.496,
    y1: 565.961,
    x2: 841.496,
    y2: 570.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 562.562,
    y1: 518.439,
    x2: 594.43,
    y2: 518.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0949175,
    stopColor: "#CED3ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4088,
    stopColor: "#E9EBF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6869,
    stopColor: "#F9FAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 611.697,
    y1: 558.167,
    x2: 611.697,
    y2: 563.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 596.904,
    y1: 552.918,
    x2: 596.904,
    y2: 558.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 584.617,
    y1: 491.52,
    x2: 564.567,
    y2: 498.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 617.254,
    y1: 490.882,
    x2: 565.122,
    y2: 533.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 609.43,
    y1: 495.103,
    x2: 585.12,
    y2: 507.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 593.842,
    y1: 480.851,
    x2: 591.368,
    y2: 487.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#5B5050"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 555.273,
    height: 375.537,
    fill: "white",
    transform: "translate(547 208)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAABaCAYAAACv1SSdAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageTeam);
export default __webpack_public_path__ + "static/media/homepage_team.8ffdcb7b2713e899433d8c2ef5305bd4.svg";
export { ForwardRef as ReactComponent };